import React, { memo, forwardRef } from 'react'
import PropTypes from 'prop-types'

import { util } from '../../../util'
import Icon from '../Icon'

const TableIconCellComponent = (
    { position = 'start', inputProps, value, label, align, className, pointer, onClick, ...rest },
    ref
) => {
    const isSuccessColor = label => {
        return !label || typeof label !== 'string'
            ? false
            : ['complete', 'published', 'approved', 'saved'].findIndex(
                  el => el.toLowerCase() === label.toLowerCase()
              ) >= 0
    }

    const isErrorColor = () => {
        return label && ['incomplete', 'Incomplete'].includes(label)
    }

    const getColor = value => {
        if (isSuccessColor(value)) {
            return 'success'
        } else if (isErrorColor()) {
            return 'warning'
        } else {
            return inputProps.hasOwnProperty('color') ? inputProps['color'] : null
        }
    }

    const renderInputProps = pos => {
        return position === pos && inputProps ? (
            <Icon
                color={getColor(value)}
                size={'xs'}
                display={'inline'}
                className={'mr-2'}
                renderIcon={inputProps[label]}
                pointer={inputProps['pointer'] || false}
            />
        ) : null
    }

    return (
        <td
            className={util.joinClasses('table-row__cell', pointer && 'pointer', align, className)}
            onClick={onClick}
            ref={ref}
            {...rest}
        >
            <span className={'flex-cell'}>
                {renderInputProps('start')}
                <span className={'flex-cell__content'}>{value}</span>
                {renderInputProps('end')}
            </span>
        </td>
    )
}

const TableIconCellWithRef = forwardRef(TableIconCellComponent)

TableIconCellWithRef.propTypes = {
    position: PropTypes.oneOf(['start', 'end']),
    inputProps: PropTypes.shape({
        LABEL_ICON_NAME: PropTypes.func,
        color: PropTypes.string,
        pointer: PropTypes.bool,
    }),
    value: PropTypes.any,
    label: PropTypes.string,
    align: PropTypes.string,
    className: PropTypes.string,
    pointer: PropTypes.bool,
    onClick: PropTypes.func,
}

const TableIconCell = memo(TableIconCellWithRef, (prev, next) => {
    return prev.value === next.value && prev.label === next.label && prev.onClick === next.onClick
})

export default TableIconCell
